import {createContext, useContext} from "react";

interface IIndicatorsPanelContextProps{
    showCheckboxes?: boolean;
    addSelectedCheckboxId: (id: number) => void;
    actionHideCheckboxes: () => void;
    addAllSelectedCheckboxesId: (id: number) => void;
    selectedCheckboxesId: number[];
}

export const IndicatorsPanelContext = createContext<IIndicatorsPanelContextProps>({} as IIndicatorsPanelContextProps);

export function useIndicatorsPanel(): IIndicatorsPanelContextProps{
	const context = useContext(IndicatorsPanelContext);

	if(!context){
		throw new Error("useIndicatorsPanel function must be used inside the IndicatorsPanel Provider.");
	}

	return context;
}
